module.exports = __webpack_public_path__ + "img/site-jle.1d332955.png";